<template>
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
  >
    <path d="M13.7466 0C15.1274 0 16.2466 1.11929 16.2466 2.5V10.5C16.2466 11.8807 15.1274 13 13.7466 13H2.74664C1.36593 13 0.246643 11.8807 0.246643 10.5V2.5C0.246643 1.11929 1.36593 0 2.74664 0H13.7466ZM15.2466 3.961L8.50015 7.93097C8.36976 8.00767 8.21325 8.02045 8.07415 7.96932L7.99313 7.93097L1.24664 3.963V10.5C1.24664 11.3284 1.91822 12 2.74664 12H13.7466C14.5751 12 15.2466 11.3284 15.2466 10.5V3.961ZM13.7466 1H2.74664C1.91822 1 1.24664 1.67157 1.24664 2.5V2.802L8.24664 6.91991L15.2466 2.801V2.5C15.2466 1.67157 14.5751 1 13.7466 1Z" />
  </svg>
</template>
